<form [formGroup]="form" autocomplete="off" class="form-horizontal m-1x mb-3x mt-3x">

  <div class="mb-5x">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="bezeichnung{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BEZEICHNUNG' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="bezeichnung{{objectId}}" formControlName="bezeichnung"
               id="bezeichnung{{index}}"
               type="text" utilsCheckValidity utilsControlState
               utilsMarkRequired utilsValidationMessage
        />
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="rechtsform{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.LABEL' | translate }}
      </label>
      <div class="col-sm-8">
        <select class="form-control" datevMessagePath="rechtsform{{objectId}}" formControlName="rechtsform"
                id="rechtsform{{index}}"
                utilsCheckValidity
                utilsValidationMessage> utilsControlState
          <option [ngValue]="null"
                  selected>{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.RECHTSFORM.NULL' | translate }}</option>
          <option *ngFor="let rechtsform of rechtsformenOptions"
                  [ngValue]="rechtsform.value">{{ rechtsform.label | translate }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.ADRESSE_TITEL' | translate }}</h2>
    <common-ui-adresserfassung
      [(inlandsadresse)]="data.inlandsadresse"
      [(postfachadresse)]="data.postfachadresse" [readonly]="readonly" disableAuslandsadresse="true"
      noAddressRequired="true">
    </common-ui-adresserfassung>
  </div>

  <div class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BETEILIGUNGSVERHAELTNIS.TITEL' | translate }}</h2>
    <div class="form-row">
      <label class="d-sm-none col-form-label"
             for="beteiligungsverhaeltnisZaehler{{index}}">
        {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BETEILIGUNGSVERHAELTNIS.ZAEHLER' | translate }}
      </label>

      <label class="d-none d-sm-inline col-sm-4 col-form-label">
        {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BETEILIGUNGSVERHAELTNIS.ZAEHLER_NENNER' | translate }}
      </label>

      <div class="col-sm-3">
        <input [checkAdditionalControls]="['beteiligungsverhaeltnisNenner']" class="form-control"
               datevMessagePath="beteiligungsverhaeltnisZaehler{{objectId}}"
               formControlName="beteiligungsverhaeltnisZaehler" id="beteiligungsverhaeltnisZaehler{{index}}"
               type="text" numeric utilsCheckValidity
               utilsControlState utilsMarkRequired utilsValidationMessage/>
      </div>

      <label class="d-sm-none col-form-label"
             for="beteiligungsverhaeltnisNenner{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BETEILIGUNGSVERHAELTNIS.NENNER' | translate }}
      </label>

      <div class="col-sm-1 d-none d-sm-inline text-center">/</div>

      <div class="col-sm-4">
        <input [checkAdditionalControls]="['beteiligungsverhaeltnisZaehler']" class="form-control"
               datevMessagePath="beteiligungsverhaeltnisNenner{{objectId}}"
               formControlName="beteiligungsverhaeltnisNenner" id="beteiligungsverhaeltnisNenner{{index}}"
               type="text" numeric utilsCheckValidity
               utilsControlState utilsMarkRequired utilsValidationMessage/>
      </div>
    </div>

    <div class="form-row mt-3x">
      <label class="col-sm-4 col-form-label"
             for="beteiligungsverhaeltnisUstIdentifikationsnummer">
        {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.BETEILIGUNGSVERHAELTNIS.USTID' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="beteiligungsverhaeltnisUstIdentifikationsnummer{{objectId}}"
               formControlName="beteiligungsverhaeltnisUstIdentifikationsnummer"
               id="beteiligungsverhaeltnisUstIdentifikationsnummer"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>

    <div class="form-row mt-3x">
      <label class="col-sm-4 col-form-label"
             for="beteiligungsverhaeltnisWirtschaftsIdNummer">
        {{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="beteiligungsverhaeltnisWirtschaftsIdNummer{{objectId}}"
               formControlName="beteiligungsverhaeltnisWirtschaftsIdNummer"
               id="beteiligungsverhaeltnisWirtschaftsIdNummer"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </div>
    </div>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFT.ORGANGESELLSCHAFT.STEUERNUMMER_TITEL' | translate }}</h2>
    <common-ui-steuernummer [(data)]="data.beteiligungsverhaeltnisSteuernummer" [readonly]="readonly"
                            index="{{index}}"></common-ui-steuernummer>
  </div>
</form>
